import React from 'react';
import { Ripple } from '@isyc-react/animation/modules/base/transition';
import { InputSelect } from '@isyc-react/form/modules/input/select';
import { DropZoneFile } from '@isyc-react/form-file/modules/drop-file/drop-zone';
import clsx from 'clsx';
import { DropSingleAcceptedMultiView } from './drop-single-accepted-multi-view.component';
import { CustomErrorDropFile, DropSingleRejectedMultiView } from './drop-single-rejected-view.component';
const DocValidationMultiFileMaxSize = 52428800; // 50 MB
// FIXME DEPRECATED --- NO BASAR NADA EN ESTE CONTENIDO.
// DROP ZONE, ACCEPTED y REJECTED actualizados para usar los componentes nuevos de la lib.
export const allowedMimeTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/tiff', 'application/pdf'];
const AcceptedMultiFile = props => {
    const { file, open, setAccepted, remove, index, disabled, uploaded, uploadedArchiveId, uploadedArchiveName, moveDown, moveUp, canDown, canUp, } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement(DropSingleAcceptedMultiView, { open: open, remove: () => remove(index), canRemove: true, canUpdate: false, canDown: canDown, canUp: canUp, moveDown: moveDown, moveUp: moveUp, accepted: {
                file: file !== null && file !== void 0 ? file : undefined,
                api: uploaded
                    ? {
                        id: uploadedArchiveId !== null && uploadedArchiveId !== void 0 ? uploadedArchiveId : 0,
                        name: uploadedArchiveName !== null && uploadedArchiveName !== void 0 ? uploadedArchiveName : '',
                    }
                    : undefined,
            } })));
};
const RejectedFile = props => {
    const { rejected, open, remove, disabled, index } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement(DropSingleRejectedMultiView, { open: open, remove: () => remove(index), rejected: rejected })));
};
const DropFileDefaultView = (props) => (React.createElement(React.Fragment, null,
    React.createElement("div", { className: 'text-center' },
        React.createElement("button", { type: 'button', className: 'btn btn-ripple btn-primary', onClick: props.open, disabled: props.disabled, "aria-label": 'Charger un document', "aria-describedby": 'Charger un document', title: 'Charger un document' },
            React.createElement(Ripple, { disabled: props.disabled }),
            "Charger un document"))));
const DropMultiFileStatus = (props) => {
    const { state, uploaded, moveUp, moveDown } = props;
    const filesSize = React.useMemo(() => {
        const acceptedSize = state.accepted && state.accepted.length > 0
            ? state.accepted.map(f => f.size).reduce((acumulador, valorActual) => acumulador + valorActual, 0)
            : 0;
        const rejectedSize = state.rejected && state.rejected.length > 0
            ? state.rejected.map(f => f.file.size).reduce((acumulador, valorActual) => acumulador + valorActual, 0)
            : 0;
        return acceptedSize + rejectedSize;
    }, [state]);
    return (React.createElement(React.Fragment, null,
        state.accepted &&
            state.accepted.map((accepted, i) => {
                var _a, _b;
                const length = (_b = (_a = state.accepted) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : -1;
                return (React.createElement("div", { className: clsx('mb-3', { 'border-bottom': i < length - 1 }) },
                    React.createElement(AcceptedMultiFile, { index: i, key: i, file: accepted, uploaded: props.uploaded, uploadedArchiveId: props.uploadedArchiveId, uploadedArchiveName: props.uploadedArchiveName, open: props.open, setAccepted: props.setAccepted, remove: props.removeAccepted, disabled: props.disabled, moveUp: () => {
                            var _a;
                            moveUp((_a = state.accepted) !== null && _a !== void 0 ? _a : [], i, i - 1);
                        }, moveDown: () => {
                            var _a;
                            moveDown((_a = state.accepted) !== null && _a !== void 0 ? _a : [], i, i + 1);
                        }, canUp: i > 0 && length > 1, canDown: i < length - 1 })));
            }),
        state.rejected &&
            state.rejected.map((rejected, i) => {
                var _a, _b;
                const length = (_b = (_a = state.rejected) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : -1;
                return (React.createElement("div", { className: clsx('mb-3', { 'border-bottom': i < length - 1 }) },
                    React.createElement(RejectedFile, { key: i, index: i, rejected: [rejected], open: props.open, remove: props.removeRejected, disabled: props.disabled })));
            }),
        filesSize > DocValidationMultiFileMaxSize ? (React.createElement("h3", { className: 'd-flex align-items-center justify-content-center text-warning' }, "Vous avez d\u00E9pass\u00E9 la taille limite du fichier 50 MB")) : (React.createElement(DropFileDefaultView, { open: props.open, disabled: props.disabled }))));
};
export const DeprecatedMultiDropFile = props => {
    var _a;
    const { minSize = 0, maxSize = Infinity, disabled = false, showDropFileStatus = true, className, onAccepted, onRejected, children, options, initialOptionSelected, disabledSelect, onOptionSelected, afterSelectChildren, uploaded, uploadedArchiveId, uploadedArchiveName, onRemoveAccepted, onRemoveRejected, } = props;
    const [selectedOption, setSelectedOption] = React.useState((_a = options === null || options === void 0 ? void 0 : options.find(o => o.value === (initialOptionSelected === null || initialOptionSelected === void 0 ? void 0 : initialOptionSelected.value))) !== null && _a !== void 0 ? _a : null);
    const [state, setState] = React.useState({
        accepted: null,
        rejected: null,
    });
    const organizeFiles = React.useCallback((files, from, to) => {
        const elementToMove = files[from];
        files.splice(from, 1);
        files.splice(to, 0, elementToMove);
        return files;
    }, []);
    const isAcceptedSizeFile = React.useCallback((newFiles) => {
        const stateSize = state.accepted && state.accepted.length > 0
            ? state.accepted.map(f => f.size).reduce((acc, newVal) => acc + newVal, 0)
            : 0;
        const newFilesSize = newFiles.length > 0 ? newFiles.map(f => f.size).reduce((acc, newVal) => acc + newVal, 0) : 0;
        return stateSize + newFilesSize <= DocValidationMultiFileMaxSize;
    }, [state]);
    return (React.createElement(React.Fragment, null,
        React.createElement(DropZoneFile, { className: className, disabled: disabled, minSize: minSize, maxSize: maxSize, multiple: false, accept: allowedMimeTypes, onDropAccepted: acceptedFiles => {
                if (isAcceptedSizeFile(acceptedFiles)) {
                    setState(state => ({
                        accepted: state.accepted ? [...state.accepted, ...acceptedFiles] : [...acceptedFiles],
                        rejected: state.rejected,
                    }));
                    onAccepted && onAccepted(state.accepted ? [...state.accepted, ...acceptedFiles] : [...acceptedFiles]);
                }
                else {
                    const newRejectedFiles = acceptedFiles.map(f => ({
                        file: f,
                        errors: [
                            {
                                message: `La limite de taille de l'ensemble de fichiers a été dépassée`,
                                code: CustomErrorDropFile.FILES_MAX_SIZE_EXCEDED,
                            },
                        ],
                    }));
                    setState(state => ({
                        rejected: state.rejected ? [...state.rejected, ...newRejectedFiles] : [...newRejectedFiles],
                        accepted: state.accepted,
                    }));
                    const rejected = state.rejected ? [...state.rejected, ...newRejectedFiles] : [...newRejectedFiles];
                    onRejected && onRejected(rejected.map(r => r.file));
                }
            }, onDropRejected: rejectedFiles => {
                setState(state => ({
                    rejected: state.rejected ? [...state.rejected, ...rejectedFiles] : [...rejectedFiles],
                    accepted: state.accepted,
                }));
                const rejected = state.rejected ? [...state.rejected, ...rejectedFiles] : [...rejectedFiles];
                onRejected && onRejected(rejected.map(r => r.file));
            } }, ({ open }) => (React.createElement(React.Fragment, null,
            children,
            options && options.length > 0 && (React.createElement("div", { className: 'mb-4' },
                React.createElement(InputSelect, { value: selectedOption, isDisabled: disabledSelect, isSearchable: false, placeholder: 'Sélectionner', options: options, noOptionsMessage: ({ inputValue }) => `Aucune option pour ${inputValue}`, onChange: selected => {
                        onOptionSelected && onOptionSelected(selected);
                        setSelectedOption(selected);
                    } }))),
            afterSelectChildren,
            showDropFileStatus && (React.createElement(DropMultiFileStatus, { state: state, open: open, disabled: disabled, uploaded: uploaded, uploadedArchiveId: uploadedArchiveId, uploadedArchiveName: uploadedArchiveName, setAccepted: (file) => {
                    setState(state => {
                        let accepted = state.accepted || file;
                        return Object.assign(Object.assign({}, state), { accepted });
                    });
                }, removeAccepted: (index) => {
                    setState(state => {
                        const backupAccepted = state.accepted ? [...state.accepted] : null;
                        if (backupAccepted) {
                            backupAccepted.splice(index, 1);
                            return Object.assign(Object.assign({}, state), { accepted: backupAccepted });
                        }
                        return Object.assign(Object.assign({}, state), { accepted: null });
                    });
                    onRemoveAccepted && onRemoveAccepted();
                }, removeRejected: (index) => {
                    setState(state => {
                        const backupAccepted = state.rejected ? [...state.rejected] : null;
                        if (backupAccepted) {
                            backupAccepted.splice(index, 1);
                            return Object.assign(Object.assign({}, state), { rejected: backupAccepted });
                        }
                        return Object.assign(Object.assign({}, state), { rejected: null });
                    });
                    onRemoveRejected && onRemoveRejected();
                }, moveUp: (files, from, to) => {
                    const newAccept = organizeFiles(files, from, to);
                    setState(state => {
                        return {
                            rejected: state.rejected,
                            accepted: newAccept,
                        };
                    });
                }, moveDown: (files, from, to) => {
                    const newAccept = organizeFiles(files, from, to);
                    setState(state => {
                        return {
                            rejected: state.rejected,
                            accepted: newAccept,
                        };
                    });
                } })))))));
};
